<template>
  <div class="category-performance-table">
    <div v-if="!categories || categories.length === 0" class="empty-state">
      <i class="fas fa-tags"></i>
      <p>No category data available</p>
    </div>

    <div v-else class="table-container">
      <table class="categories-table">
        <thead>
          <tr>
            <th>Category</th>
            <th class="text-right">Revenue</th>
            <th class="text-right">% of Total</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in sortedCategories" :key="category.category_id" class="category-row">
            <td>
              <a class="category-name" :href="categoryLink(category)">{{ category.name }}</a>
              <div class="category-meta">{{ category.product_count }} products</div>
            </td>

            <td class="text-right">
              <span class="revenue-value">KES {{ formatNumber(category.revenue) }}</span>
            </td>

            <td class="text-right">
              <div class="percent-cell">
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: category.percent_of_total + '%' }"></div>
                </div>
                <span class="percent-text">{{ category.percent_of_total }}%</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryPerformanceTable',

  props: {
    categories: {
      type: Array,
      required: true
    },
    startDate: {
      type: String,
      default: ''
    },
    endDate: {
      type: String,
      default: ''
    }
  },

  computed: {
    sortedCategories() {
      return [...this.categories].sort((a, b) => b.revenue - a.revenue);
    }
  },

  methods: {
    categoryLink(category) {
      return `/analytics/category-sales?category-id=${category.category_id}&start-date=${this.startDate}&end-date=${this.endDate}&from=beta`;
    },

    formatNumber(value, decimals = 2) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }).format(value);
    }
  }
};
</script>

<style scoped>
.category-performance-table {
  height: 100%;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #94a3b8;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.table-container {
  overflow-x: auto;
}

.categories-table {
  width: 100%;
  border-collapse: collapse;
}

.categories-table thead {
  border-bottom: 2px solid #e2e8f0;
}

.categories-table th {
  padding: 12px 16px;
  text-align: left;
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.categories-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s;
}

.categories-table tbody tr:hover {
  background: #f8fafc;
}

.categories-table td {
  padding: 14px 16px;
}

.category-name {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}

.category-meta {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

.text-right {
  text-align: right;
}

.revenue-value {
  font-weight: 700;
  color: #1e293b;
  font-size: 14px;
}

.percent-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.progress-bar {
  width: 80px;
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.percent-text {
  font-size: 12px;
  font-weight: 700;
  color: #3b82f6;
}
</style>
